export default __webpack_public_path__ + "static/char-s-17-chs-a1885de106ffe284002af3809b85378a.webp";